import { Quill } from "@vueup/vue-quill";

export const useInitializeToolbar = (quill: any) => {
  // Intercept color and background toolbar actions
  const toolbar = quill.getModule("toolbar");
  if (toolbar) {
    // Override color handler
    toolbar.handlers.color = function (value: any) {
      const range = quill.getSelection();
      if (range && range.length > 0) {
        // 1. Get the selection range
        const { index, length } = range;

        // 2. Remove existing color formatting from the entire range (only color attribute)
        quill.formatText(index, length, "color", false, Quill.sources.USER);

        // 3. Apply the new color
        if (value) {
          quill.formatText(index, length, "color", value, Quill.sources.USER);
        }
      } else {
        // No selection, just set the format for future typing
        quill.format("color", value, Quill.sources.USER);
      }
    };

    // Override background handler
    toolbar.handlers.background = function (value: any) {
      const range = quill.getSelection();
      if (range && range.length > 0) {
        // 1. Get the selection range
        const { index, length } = range;

        // 2. Remove existing background formatting from the entire range (only background attribute)
        quill.formatText(
          index,
          length,
          "background",
          false,
          Quill.sources.USER
        );

        // 3. Apply the new background
        if (value) {
          quill.formatText(
            index,
            length,
            "background",
            value,
            Quill.sources.USER
          );
        }
      } else {
        // No selection, just set the format for future typing
        quill.format("background", value, Quill.sources.USER);
      }
    };
  }
};
